module.exports = __webpack_public_path__ + "media/images/emblems/GW-FR-Le-Mouret-963e07da8ca7cf8e6e15c3c04f237fd6.png";